import React from "react";
import 'bootstrap/dist/css/bootstrap.css'

export default function loading(props) {
    const {id} = props;

    return (
        <div className="spinner-border me-1 spinner-border-sm"
             role="status"
             style={{display: props.hidden ? "none" : "inline-block"}}
             id={id}
        >
            <span className="visually-hidden">Loading...</span>
        </div>
    );

}